import { PrimaryButton, SecondaryButton, Select } from '@weareopenr/component-library';
import { TOption } from '@weareopenr/component-library/build/components/Select/Select';
import { Controller, useForm } from 'react-hook-form';
import { ButtonContainer } from 'src/components/ButtonContainer/ButtonContainer';
import { IPriceScheme } from 'src/types/price.types';
import { PriceSchemeNameInput } from '../../PriceSchemeNameInput';

type Props = {
  priceSchemes: IPriceScheme[];
  submitting: boolean;
  cancelText: string;
  onCancel: () => void;
  onSubmit: (t: TDuplicatePriceSchemeSchema) => void;
};

type TDuplicatePriceSchemeSchema = {
  schemeId: string | undefined;
  name: string | undefined;
};

const DuplicateSchemeStep = ({ onCancel, onSubmit, cancelText, submitting, priceSchemes = [] }: Props) => {
  const formFields = useForm<TDuplicatePriceSchemeSchema>({
    defaultValues: { name: undefined },
  });
  const { formState, handleSubmit, control } = formFields;

  const submitForm = (fields: TDuplicatePriceSchemeSchema) => onSubmit(fields);

  const formValid = formState.isValid;

  const options: TOption[] = priceSchemes.map((p) => ({ name: p.name, value: p.id }));

  return (
    <form onSubmit={handleSubmit(submitForm)} style={{ flexDirection: 'column', display: 'flex', rowGap: 24 }}>
      <Controller
        name="schemeId"
        control={control}
        rules={{ required: true }}
        render={(state) => (
          <Select
            name={state.field.name}
            onChange={state.field.onChange}
            label="Choose an existing Scheme to duplicate"
            value={state.field.value}
            options={options}
          />
        )}
      />
      <PriceSchemeNameInput formFields={formFields} />
      <ButtonContainer
        left={
          <SecondaryButton data-cy="cancel-button" buttonStyle="outline" onClick={onCancel} size="full-width">
            {cancelText}
          </SecondaryButton>
        }
        right={
          <PrimaryButton
            data-cy="create-button"
            disabled={!formValid}
            loading={submitting}
            size="full-width"
            type="submit"
          >
            Create
          </PrimaryButton>
        }
      />
    </form>
  );
};

export default DuplicateSchemeStep;
